import api from "../../api/api"; // ajuste o caminho conforme seu projeto

export const aluguelService = {
  // ── CRUD principal ──────────────────────────────────────────────────────────
  getAll: (params) => api.get("/aluguel", { params }).then((r) => r.data),
  getById: (id) => api.get(`/aluguel/${id}`).then((r) => r.data),
  create: (data) => api.post("/aluguel", data).then((r) => r.data),
  update: (id, data) => api.put(`/aluguel/${id}`, data).then((r) => r.data),

  // ── Status ──────────────────────────────────────────────────────────────────
  updateStatus: (id, status, data_real = null, force_recalcular = false) =>
    api
      .patch(`/aluguel/${id}/status`, { status, data_real, force_recalcular })
      .then((r) => r.data),

  // ── Pagamentos ───────────────────────────────────────────────────────────────
  getPagamentos: (id) =>
    api.get(`/aluguel/${id}/pagamentos`).then((r) => r.data),
  registrarPagamento: (id, data) =>
    api.post(`/aluguel/${id}/pagamento`, data).then((r) => r.data),

  // ── Disponibilidade ──────────────────────────────────────────────────────────
  verificarDisponibilidade: (produto_id, data_retirada, data_devolucao) =>
    api
      .get("/aluguel/disponibilidade", {
        params: { produto_id, data_retirada, data_devolucao },
      })
      .then((r) => r.data),

  // ── Documentos ───────────────────────────────────────────────────────────────
  getContrato: (id) => api.get(`/aluguel/${id}/contrato`).then((r) => r.data),
  getComprovante: (id) =>
    api.get(`/aluguel/${id}/comprovante`).then((r) => r.data),

  // ── Produtos alugáveis ────────────────────────────────────────────────────────
  getProdutosAlugaveis: () =>
    api.get("/produtos", { params: { tipo: "alugavel" } }).then((r) => r.data),
};
